module.exports = __webpack_public_path__ + "media/images/pokerroom/888/step2-pict03-be9d572f88a6e1c09d0ac427cbbaa40c.jpg";